import tw, { styled } from 'twin.macro';

const Heading2 = styled.h2`
  ${tw`text-xl md:text-4xl leading-10 font-bold mb-5 md:mb-6 relative z-[2]`};
  ${tw`print:!text-lg`}
  line-height: 1.3;
`;

export default Heading2;
